import axios from 'axios';
import Notice from './notice.base';
import router from '../router/router.js';
import { Loading } from 'element-ui';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let host = "";

if (process.env.NODE_ENV === "development")
    // host = 'http://partnerManageServer/';
    // host = 'http://192.168.254.40/';
    host = 'http://cap.com/';
else
    // host = '/partnerManageServer';
    host = '/';

// 测试
axios.defaults.baseURL = host + "partnerManageServer/";
// 正式环境
// axios.defaults.baseURL = host + "/";
let loadingInstance;

// 添加请求拦截器
axios.interceptors.request.use(function (config) {

    loadingInstance = Loading.service();
    config.headers.common['x-auth-token'] = localStorage.getItem("producttoken");
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    let data = response.data;
    loadingInstance.close();
    if (data.code !== 0) return Promise.reject(data);
    return data;
}, function (error) {
    return Promise.reject(error);
});

// 遵守 RESETful 规范,对应增删改查方法 
export default class HttpRequest {
    constructor() {
        this.http = axios;
        this.host = host;
    }

    get(url, params, successCall, errorCall = () => { }) {
        this.http.get(url, {
            params
        }).then(successCall).catch(createRejection(errorCall));
    }

    post(url, params, successCall, errorCall = () => { }) {
        let newParams;
        if (params instanceof FormData) {  //上传文件时传递FormData
            newParams = params;
        }
        else {
            newParams = new URLSearchParams();
            for (let i in params)
                newParams.append(i, params[i]);
        }
        this.http.post(url, newParams).then(successCall).catch(createRejection(errorCall));
    }

    put(url, params, successCall, errorCall = () => { }) {
        let newParams = new URLSearchParams();
        for (let i in params)
            newParams.append(i, params[i]);
        this.http.put(url, newParams).then(successCall).catch(createRejection(errorCall));
    }

    delete(url, params, successCall, errorCall = () => { }) {
        this.http.delete(url, {
            params
        }).then(successCall).catch(createRejection(errorCall));
    }

    // TODO all
}

let notice = new Notice();

let showNotice = true;
function createRejection(callback) {
    return (error) => {

        switch (error.code) {
            case 1:
                notice.messageBox("alert", error.msg, "Error", "error")(() => {
                });
                break;
            case 2:
                if (showNotice) {
                    localStorage.removeItem('producttoken');
                    showNotice = false;
                    //修改：添加方法的第二个参数errorCall
                    notice.messageBox("alert", error.msg, "Error", "error")(() => {
                        showNotice = true;
                        router.replace('/login');
                    }, () => {
                        showNotice = true;
                        router.replace('/login');
                    });

                }
                break;
            default:
                break;
        }
        callback(error);
    };
}